"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = __importDefault(require("styled-components"));

const Column_1 = __importDefault(require("../column/Column"));

const Dialog = styled_components_1.default(Column_1.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: white;\n  padding: 32px;\n"])));
exports.default = Dialog;